import * as DropdownMenu from '@radix-ui/react-dropdown-menu'

import { FxIcon } from '@/components/fx'
import { cn } from '@/lib/utils'

/**
 * The row's kebab: Umbenennen, Freigeben, Löschen — the three the artboard
 * names in its own `aria-label`.
 *
 * Radix gives it the menu semantics, the arrow-key roving focus and the
 * return of focus to the trigger; the trigger carries the project's name so
 * a screen reader announces which row's menu is opening, rather than
 * fourteen buttons all called "Aktionen".
 */
export function FolderActionsMenu({
  name,
  onRename,
  onShare,
  onDelete,
}: {
  name: string
  onRename: () => void
  onShare: () => void
  onDelete: () => void
}) {
  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button
          type="button"
          className="flex h-9 w-9 flex-none items-center justify-center rounded-sm text-text"
          aria-label={`Aktionen für ${name}: Umbenennen, Freigeben, Löschen`}
        >
          <FxIcon name="more_vert" size={22} />
        </button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content
          align="end"
          sideOffset={4}
          collisionPadding={8}
          className="z-50 min-w-[220px] rounded-xl bg-surface p-2 text-body text-text shadow-overlay"
        >
          <DropdownMenu.Item asChild>
            <button type="button" className={itemStyles} onClick={onRename}>
              <FxIcon name="edit" size={22} />
              Umbenennen
            </button>
          </DropdownMenu.Item>
          <DropdownMenu.Item asChild>
            <button type="button" className={itemStyles} onClick={onShare}>
              <FxIcon name="group_add" size={22} />
              Freigeben
            </button>
          </DropdownMenu.Item>
          <DropdownMenu.Item asChild>
            <button
              type="button"
              className={cn(itemStyles, 'text-danger-text')}
              onClick={onDelete}
            >
              <FxIcon name="delete" size={22} />
              Löschen
            </button>
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  )
}

const itemStyles = cn(
  'flex w-full cursor-pointer items-center gap-3 rounded-sm px-3 py-2 text-left outline-none',
  'data-[highlighted]:bg-primary-subtle data-[highlighted]:text-primary-text',
)
